export default {
  recurrenceList: ['Daily', 'Weekly', 'Monthly', 'Quarterly'],
  timePeriodList: ['Custom date range', 'Yesterday', 'Last week', 'Last month', 'Last quarter', 'Past 7 days', 'Past 30 days', 'Quarter to date'],
  dictionaryList: [],
};
